/**
 * Profils d'un CONTACT externe (`tk_users_ext.role`) — SOURCE UNIQUE du frontend.
 *
 * Miroir de backend `services/contact_roles_svc.PROFILS_CONTACT` (registre #20266
 * 8f9fdcc1, décision William 25/09 : une seule définition des rôles externes, sens
 * contact client). Aucun import : ce module doit rester chargeable partout (Jest compris).
 *
 * Ne pas confondre avec le rôle de COMPTE `client` (`portal_users.role`) : autre
 * vocabulaire, nommé `EXTERNAL_ACCOUNT_ROLES` dans lib/roles.js
 * (cf. reference_rights_architecture.md § « Contact ≠ Compte »).
 */

export const CONTACT_PROFILE_DEFAUT = 'utilisateur';

export const CONTACT_PROFILES = Object.freeze([
  'utilisateur',
  'superviseur',
  'comptable',
  'directeur',
]);

// Profils « élevés » : voient tous les documents de leur société (miroir de
// documents_svc.ELEVATED_CLIENT_ROLES).
export const CONTACT_PROFILES_ELEVES = Object.freeze(
  CONTACT_PROFILES.filter(p => p !== CONTACT_PROFILE_DEFAUT),
);
